module.exports = __webpack_public_path__ + "media/images/WFC_Award_White_w_0-00b181306e70bfb2d259413653d5ad5c.svg";